module.exports = ".Xcontainer {\r\n    max-width: 960px;\r\n}\r\n\r\nmd-card {\r\n    margin-top: 10px;\r\n    margin-left: 4px;\r\n    margin-right: 4px;\r\n}"